const _ = require('lodash');

export default function numberOnly(string) {
    return _.replace(string, /[^0-9]/g, '') ?? undefined;
}
